<template>
  <div
    class="custom-control__select"
    :class="{
      opened: opened,
      'custom-control__select--absolute': absolute,
      'custom-control__select--small': small,
      'custom-control__select--medium': medium,
      'has-error': error && selected != {}
    }"
  >
    <div
      class="custom-control__select__selected"
      :class="{ opened: opened }"
      @click="toggleList()"
    >
      <span style="position: relative; width: 100%; display: block;">
        <input
          ref="search"
          v-model="search"
          :style="{ visible: this.opened }"
          style="background: transparent; border: none !important; outline: none; color: #5d696b;"
          tabindex="1"
          type="text"
          @keydown="searchInList()"
          @keyup="searchInList()"
        />

        <span
          v-if="selected && search.length == 0"
          style="position: absolute; top: 0; left: 0; width: 100%; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;"
          class="gray-text"
        >{{ selected[name] }}</span>
      </span>
    </div>
    <div
      v-if="items"
      class="custom-control__select__options"
      :class="{ opened: opened }"
    >
      <div
        v-for="(item, index) in filtered"
        :key="index"
        class="custom-control__select__option d-flex align-items-center"
        @click="selectItem(item)"
      >
        <div class="check">
          <img
            v-if="item === selectedItem"
            src="@/assets/icons/check.svg"
            class=""
          />
        </div>
        <span class="font-weight-light">{{ item[name] }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    items: Array,
    loading: Boolean,
    name: String,
    selectedItem: Object,
    absolute: Boolean,
    small: Boolean,
    medium: Boolean,
    error: Boolean
  },
  data() {
    return {
      search: "",
      opened: false,
      selected: {},
      filtered: [],
      preselected: {}
    };
  },
  computed: {
    listItemName() {
      return this.name ? "item." + this.name : "item";
    },
    selectedItemName() {
      return this.name ? "selectedItem." + this.name : "selectedItem";
    }
  },
  watch: {
    selectedItem() {
      this.selected = this.selectedItem;
    }
  },
  created() {},
  mounted() {
    if (this.selectedItem) {
      this.selected = this.selectedItem;
    }
  },
  methods: {
    selectItem(item) {
      this.opened = false;
      this.$emit("selectItem", item);
    },
    toggleList() {
      this.opened = this.opened ? false : true;
      this.filtered = this.items;
      console.log("this.filtered", this.filtered);

      this.$nextTick(() => this.$refs.search.focus());
    },
    searchInList() {
      this.filtered = this.items.filter(item => {
        return (
          item[this.name].toLowerCase().indexOf(this.search.toLowerCase()) > -1
        );
      });
    },
    prevCustomer() {
      let index = this.cust.indexOf(this.preselectedCustomer);
      if (index >= 1) {
        this.preselectedCustomer = this.cust[index - 1];
        this.fixScrolling();
      }
    },
    nextCustomer() {
      let index = this.items.indexOf(this.preselected);
      if (index < this.items.length - 1) {
        this.items = this.customersProjects[index + 1];
        this.fixScrolling();
      }
    },
    fixScrolling() {
      document.documentElement.scrollTop = 0;
      let index, optH;
      if (this.openedSelect === "customers") {
        index = this.cust.indexOf(this.preselectedCustomer);
        optH = this.$refs.options[index].clientHeight;
        this.$refs.scrollContainer.scrollTop = optH * index;
      } else if (this.openedSelect === "projects") {
        index = this.customersProjects.indexOf(this.preselectedProject);
        optH = this.$refs.options1[index].clientHeight;
        this.$refs.scrollContainer1.scrollTop = optH * index;
      }
    }
  }
};
</script>

<style scoped></style>
